import BaseVueComponent from "../../_imports/shared/base-vue-component.vue.common";
import formStore from './store/form';

export default {
	mixins: [
		BaseVueComponent
	],
    inject: [
        'getForm',
        'getFormEvent',
    ],
    computed: {
        form() {
            return this.getForm();
        },
        formEvent() {
            return this.getFormEvent();
        },
        formState() {
            return formStore.formState;
        }
    }
};